<template>
  <IQOS
    :title="employee ? employee.name : $t('navbar.corporate_users')"
    required
    enabled
  >
    <template #actions>
      <p
        v-if="employee && !employee.activated"
        class="iqos-comment qrw-heading-xs orange-4-color"
      >
        {{ $t("employee_card.not_activated") }}
      </p>
      <p
        v-if="employee && employee.activated"
        class="iqos-comment qrw-heading-xs green-5-color"
      >
        {{ $t("employee_card.activated") }}
      </p>
    </template>
    <p v-if="!employee" class="iqos-comment mt-16 qrw-paragraph-md">
      {{ $t("add_employee.comment") }}
    </p>
    <p
      v-if="employee && !employee.activated"
      class="iqos-comment qrw-paragraph-md mt-16 orange-4-color"
    >
      {{ $t("employee_card.not_activated_desc") }}
    </p>
    <p
      v-if="employee && employee.activated"
      class="iqos-comment qrw-paragraph-md mt-16"
    >
      {{ $t("employee_card.activated_desc") }}
    </p>
    <BaseDivider color="v1-grey-6" class="mt-16 mb-16" />
    <div class="row">
      <div class="access-column" v-if="!employee">
        <BaseInput
          class="w-100"
          fullWidth
          :readonly="readonly"
          :valid="!outlined || add_form.name"
          v-model="add_form.name"
          :placeholder="$t('add_employee.name_ph')"
        />
        <BaseInput
          class="mt-8 w-100"
          fullWidth
          :readonly="readonly"
          :valid="!outlined || add_form.role"
          :placeholder="$t('add_employee.role_ph')"
          v-model="add_form.role"
        />
        <BaseInput
          class="mt-8 w-100"
          fullWidth
          :readonly="readonly"
          :valid="!outlined || add_form.email"
          v-model="add_form.email"
          :placeholder="$t('add_employee.email_ph')"
        />
        <BaseInput
          class="mt-8 w-100"
          fullWidth
          :readonly="readonly"
          v-model="add_form.phone"
          :valid="!outlined || add_form.phone"
          :placeholder="$t('add_employee.phone_ph')"
        />
      </div>
      <div class="access-column" v-else>
        <BaseInput
          class="w-100"
          fullWidth
          :disabled="true"
          v-model="employee.name"
          :placeholder="$t('add_employee.name_ph')"
        />
        <BaseInput
          class="mt-8 w-100"
          fullWidth
          :disabled="true"
          :placeholder="$t('add_employee.role_ph')"
          v-model="employee.role"
        />
        <BaseInput
          class="mt-8 w-100"
          fullWidth
          :disabled="true"
          v-model="employee.email"
          :placeholder="$t('add_employee.email_ph')"
        />
        <BaseInput
          class="mt-8 w-100"
          fullWidth
          :disabled="true"
          v-model="employee.phone"
          v-if="employee.phone"
          :placeholder="$t('add_employee.phone_ph')"
        />
      </div>
      <div class="access-column ml-24">
        <template v-if="true">
          <BaseSelect class="w-100" fullWidth v-model="selected_cafe_id">
            <option
              v-for="cafe in corporate_cafes"
              :key="cafe._id"
              :value="cafe._id"
            >
              {{ cafe.name }} ({{ cafe.address }})
            </option>
          </BaseSelect>
          <BaseDivider class="mt-16" color="v1-grey-6" />

          <BaseCheckbox
            :value="selectedFullAccess || hasPermission('*')"
            @input="togglePermission('*')"
            class="mt-16"
          >
            <span :class="hasPermission('*') ? '' : 'unselected-permission'">
              {{ $t(`corporate_employees.all_permissions.*`) }}
            </span></BaseCheckbox
          >

          <BaseDivider class="mt-16" color="v1-grey-6" />
          <div
            :class="{
              'mt-16': true,
            }"
            v-for="permission in all_permissions"
            :key="permission"
          >
            <BaseCheckbox
              :value="selectedFullAccess || hasPermission(permission)"
              @input="togglePermission(permission)"
              :disabled="hasPermission('*')"
            >
              <span
                :class="
                  hasPermission(permission) ? '' : 'unselected-permission'
                "
              >
                {{ $t(`corporate_employees.all_permissions.${permission}`) }}
              </span></BaseCheckbox
            >
          </div>
        </template>
      </div>
    </div>
    <BaseDivider color="v1-grey-6" class="mt-16 mb-16" />
    <div class="new-buttons-container" v-if="!employee">
      <BaseButton
        variant="secondary"
        color="v1-grey-6"
        size="md"
        @click="$emit('close')"
        >{{ $t("add_employee.cancel") }}</BaseButton
      >

      <BaseButton
        variant="primary"
        color="green-5"
        size="md"
        icon="telegram-bold"
        :disabled="busy"
        @click="addEmployee"
        >{{ $t("add_employee.confirm") }}</BaseButton
      >
    </div>
    <div class="existing-buttons-container" v-else>
      <BaseButton
        variant="secondary"
        icon="trash"
        color="red-4"
        size="md"
        @click="removeEmployee"
      >
        {{
          !employee.activated
            ? $t("employee_card.cancel_invite")
            : $t("employee_card.delete_button")
        }}
      </BaseButton>
    </div>
  </IQOS>
</template>
<script>
import EmployeesAPI from "@/api/employees";

export default {
  data() {
    return {
      all_permissions: [
        "general",
        "stats",
        "marketing",
        "systems",
        "menu",
        "integrations",
        "payment",
      ],

      add_form: {
        name: null,
        email: null,
        role: null,
        //cafe_id: null, //-- deprecated, use array instead
        cafe_ids: [],
        permissions: {},
        phone: null,
      },

      selected_cafe_id: null,

      busy: false,

      outlined: false,

      form_invalid: false,
    };
  },
  props: {
    status: {
      type: String,
      default: "empty",
    },
    employee: Object,
  },
  watch: {
    selected_cafe_id() {
      if (!this.permissionsContainer[`${this.selected_cafe_id}`]) {
        this.$set(this.permissionsContainer, `${this.selected_cafe_id}`, []);
      }
    },
  },
  methods: {
    togglePermission(perm) {
      const target_container = this.employee ? this.employee : this.add_form;
      const container_key = `${this.selected_cafe_id}`;
      let target_array = target_container.permissions[container_key];

      if (!target_array) {
        target_array = [];
        target_container.permissions[container_key] = target_array;
      }

      const index = target_array.findIndex((p) => perm == p);

      if (index === -1) {
        target_array.push(perm);
      } else {
        target_array.splice(index, 1);
      }

      if (this.employee) {
        this.updateEmployee();
      }
    },
    isCafeSelected(id) {
      const container = this.employee
        ? this.employee.cafe_ids
        : this.add_form.cafe_ids;

      return container.includes(`${id}`);
    },
    showOutline() {
      this.outlined = true;
    },
    selectCafe(id, value) {
      const selected = this.isCafeSelected(id);

      const container = this.employee
        ? this.employee.cafe_ids
        : this.add_form.cafe_ids;

      if (selected) {
        const idx = container.indexOf(`${id}`);

        if (container.length > 1) {
          container.splice(idx, 1);
          if (this.selected_cafe_id == id)
            this.selected_cafe_id = this.selectedCorporateCafes[0]
              ? this.selectedCorporateCafes[0]._id
              : null;
        }
      } else {
        container.push(`${id}`);
      }
      const perms_map = this.employee
        ? this.employee.permissions
        : this.add_form.permissions;

      if (!perms_map[id]) this.$set(perms_map, id, []);

      if (this.employee) this.updateEmployee();
    },
    hasPermission(perm) {
      return this.currentAllowedPermissions.includes(perm);
    },
    addEmployee() {
      if (this.busy) return;

      this.add_form.cafe_ids = Object.entries(this.add_form.permissions)
        .filter((e) => e[1] && e[1].length)
        .map((e) => e[0]);

      if (
        !this.add_form.name ||
        !this.add_form.email ||
        !this.add_form.role ||
        !this.add_form.cafe_ids.length ||
        !this.add_form.permissions
      ) {
        this.form_invalid = true;
        return;
      }

      this.busy = true;

      EmployeesAPI.addEmployee(this.add_form)
        .then((data) => {
          this.$emit("added");
          this.busy = false;

          this.$store.dispatch("auditlog/write", {
            type: "add_employee",
            payload: {
              name: this.add_form.name,
              email: this.add_form.email,
              permissions: this.add_form.permissions,
            },
          });

          this.add_form = {
            name: null,
            email: null,
            role: null,
            cafe_ids: [],
            permissions: {},
            phone: null,
          };
        })
        .catch((error) => {
          this.$store.dispatch("showError", "employees_error");
          this.busy = false;
        });
    },
    cancel() {
      this.$emit("cancel");
    },
    removeEmployee() {
      EmployeesAPI.removeEmployee(this.employee._id)
        .then((data) => {
          this.$store.dispatch("auditlog/write", {
            type: "remove_employee",
            payload: {
              name: this.employee.name,
              email: this.employee.email,
            },
          });

          this.$emit("removed");
        })
        .catch((error) => {
          this.$store.dispatch("showError", "employees_error");
        });
    },
    updateEmployee() {
      this.employee.cafe_ids = Object.entries(this.employee.permissions)
        .filter((e) => e[1] && e[1].length)
        .map((e) => e[0]);

      EmployeesAPI.updateEmployee(this.employee._id, this.employee)
        .then((ok) => {
          this.$emit("updated");

          this.$store.dispatch("auditlog/write", {
            type: "update_employee",
            payload: {
              name: this.employee.name,
              email: this.employee.email,
              id: this.employee._id,
              permissions: this.employee.permissions,
            },
          });
        })
        .catch((error) => {
          this.$store.dispatch("showError", "employees_error");
        });
    },
  },
  mounted() {
    if (!this.employee) {
      this.selected_cafe_id = this.corporate_cafes[0]._id;
      // this.add_form.cafe_id = this.corporate_cafes[0]._id;
    } else {
      this.add_form = this.employee;

      this.selected_cafe_id = this.employee.cafe_ids[0];
    }
  },
  computed: {
    readonly() {
      return !!this.employee;
    },
    corporate_cafes() {
      return this.$store.state.corporate_cafes;
    },
    isSingleCafe() {
      return this.corporate_cafes.length == 1;
    },
    current_cafe() {
      return this.$store.state.cafe;
    },
    countryBasedPhoneMask() {
      return this.$store.getters["worldwide/phoneMask"];
    },
    selectedFullAccess() {
      if (this.employee) {
        return this.currentAllowedPermissions.includes("*");
      }
      return this.currentAllowedPermissions.includes("*");
    },
    permissionsContainer() {
      const container = this.employee
        ? this.employee.permissions
        : this.add_form.permissions;

      return container;
    },
    selectedChain() {
      return this.$store.state.selected_chain;
    },
    selectedCorporateCafes() {
      return this.corporate_cafes.filter((c) => this.isCafeSelected(c._id));
    },
    currentAllowedPermissions() {
      return this.permissionsContainer[this.selected_cafe_id] || [];
    },
  },
};
</script>
<style scoped>
.access-column {
  width: 100%;
}

.row {
  display: flex;
  justify-content: space-between;
}

.new-buttons-container {
  display: flex;
  justify-content: space-between;
}

.existing-buttons-container {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  text-align: right;
  width: 100%;
}
</style>
